import { useAuth } from '../contexts/AuthContext';
import { isNewUiUser } from './access';

/**
 * Whether the signed-in account may see the /v2 revamp.
 *
 * Reads the Firebase identity rather than the backend profile so the answer is
 * available immediately on first paint — waiting on a profile fetch would flash
 * the fallback route before letting an allowlisted user through.
 *
 * Admin impersonation resolves to the IMPERSONATED user's email, which is the
 * behaviour we want: viewing a customer's account should show what that customer
 * sees, not the revamp.
 */
export function useNewUiAccess(): { allowed: boolean; email: string | null } {
  const { user } = useAuth();
  const email = user?.email ?? null;
  return { allowed: isNewUiUser(email), email };
}
